import { getMoneyProBuyButtonConfig } from '../utils/moneyProEntitlements';

export const ZB_MONEY_PRO_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.zbMoneyPro.buyBox.bulletPoint1' },
        { title: 'productPage.zbMoneyPro.buyBox.bulletPoint2' },
        { title: 'productPage.zbMoneyPro.buyBox.bulletPoint3' }
      ],
      packageName: 'productPage.zbMoneyPro.optionLabel.option1',
      productName: 'productPage.zbMoneyPro.buyBox.productName1',
      interactService: {
        service: 'zb_money_pro_month',
        interval: 'monthly'
      }
    },
    {
      bulletPoints: [
        { title: 'productPage.zbMoneyPro.buyBox.bulletPoint1' },
        { title: 'productPage.zbMoneyPro.buyBox.bulletPoint2' },
        { title: 'productPage.zbMoneyPro.buyBox.bulletPoint3' }
      ],
      packageColor: 'palette.background.green.main',
      packageName: 'productPage.zbMoneyPro.optionLabel.option2',
      productName: 'productPage.zbMoneyPro.buyBox.productName2',
      packageNote: 'productPage.zbMoneyPro.optionLabel.option2Callout',
      packageLabel: 'productPage.zbMoneyPro.buyBox.boxLabel2',
      interactService: {
        service: 'zb_money_pro_year',
        interval: 'annual'
      }
    }],
    headerPicture: {
      src: '/s2/raster/apron-review-tablet-kitchen.png',
      alt: 'productPage.zbMoneyPro.heroPicture.altText'
    },
    headline: 'productPage.zbMoneyPro.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.zbMoneyPro.page.subheader'
  },
  showCase: {
    title: 'productPage.zbMoneyPro.showCase.title',
    stylesItem: {
      variantItem: 'outlined'
    },
    items: [
      {
        image: '/s2/raster/mp-mileage-mockup.png',
        alt: ''
      },
      {
        image: '/s2/raster/mp-expenses-mockup.png',
        alt: ''
      },
      {
        image: '/s2/raster/mp-invoices-mockup.png',
        alt: ''
      },
      {
        image: '/s2/raster/mp-reports-mockup.png',
        alt: ''
      }
    ]
  },
  benefit: {
    title: 'productPage.zbMoneyPro.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/trackchangesrounded.svg',
        title: 'productPage.zbMoneyPro.valueProp.propTitle1',
        description: 'productPage.zbMoneyPro.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/folderopenrounded.svg',
        title: 'productPage.zbMoneyPro.valueProp.propTitle2',
        description: 'productPage.zbMoneyPro.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/paymentsrounded.svg',
        title: 'productPage.zbMoneyPro.valueProp.propTitle3',
        description: 'productPage.zbMoneyPro.valueProp.shortCopy3'
      },
      {
        icon: '/s2/material-icons/paidrounded.svg',
        title: 'productPage.zbMoneyPro.valueProp.propTitle4',
        description: 'productPage.zbMoneyPro.valueProp.shortCopy4'
      },
      {
        icon: '/s2/material-icons/receiptrounded.svg',
        title: 'productPage.zbMoneyPro.valueProp.propTitle5',
        description: 'productPage.zbMoneyPro.valueProp.shortCopy5'
      },
      {
        icon: '/s2/material-icons/speedrounded.svg',
        title: 'productPage.zbMoneyPro.valueProp.propTitle6',
        description: 'productPage.zbMoneyPro.valueProp.shortCopy6'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/radarrounded.svg',
    title: 'productPage.zbMoneyPro.topFeature.title',
    subheader: 'productPage.zbMoneyPro.topFeature.subheader',
    image: '/s2/raster/cafe-sign-open-couple.png',
    alt: 'productPage.zbMoneyPro.topFeature.altText'
  },
  socialProof: {
    image: '/s2/raster/laptop-boxes-packing-clothes.png',
    alt: 'productPage.zbMoneyPro.testimonial.altText',
    testimonial: {
      quote: 'productPage.zbMoneyPro.testimonial.quote',
      source: 'productPage.zbMoneyPro.testimonial.source',
      author: 'productPage.zbMoneyPro.testimonial.author'
    }
  },
  faqs: {
    title: 'productPage.zbMoneyPro.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.zbMoneyPro.frequentlyAskedQuestions.faq1',
        answer: 'productPage.zbMoneyPro.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.zbMoneyPro.frequentlyAskedQuestions.faq2',
        answer: 'productPage.zbMoneyPro.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.zbMoneyPro.frequentlyAskedQuestions.faq3',
        answer: 'productPage.zbMoneyPro.frequentlyAskedQuestions.faqAnswer3'
      },
      {
        question: 'productPage.zbMoneyPro.frequentlyAskedQuestions.faq4',
        answer: 'productPage.zbMoneyPro.frequentlyAskedQuestions.faqAnswer4'
      },
      {
        question: 'productPage.zbMoneyPro.frequentlyAskedQuestions.faq5',
        answer: 'productPage.zbMoneyPro.frequentlyAskedQuestions.faqAnswer5'
      }
    ]
  },
  assistance: {
    title: 'productPage.zbMoneyPro.needAssistance.title',
    getInTouch: 'productPage.zbMoneyPro.needAssistance.getInTouch',
    actions: 'productPage.zbMoneyPro.needAssistance.actions'
  },
  getBuyButtonConfig: getMoneyProBuyButtonConfig
};
